import React, { useEffect, useRef, useState } from 'react';
import { GET_INTERNSHIP_AGGREGATE_DATA } from '../../api';
import { capitalize } from "../../utils/capitalize";
import moment from "moment/moment";
import cogoToast from "cogo-toast";
import { getInternshipReport, updateInternshipStatus } from "../../api/app";
import $ from "jquery";
import formatNumber from "../../utils/formatNumber";

let searchableFields = [
    { field: 'user.name', isNumeric: false },
    { field: 'phone_number', isNumeric: false },
    { field: 'email', isNumeric: false }
];

let filter = {};

// Same institution list as the mobile app — maps the stored slug back to its name
const INSTITUTIONS = [
    "Ministry of Defence",
    "Ministry of Mines and Minerals Development",
    "Ministry of Agriculture",
    "Ministry of Justice",
    "Ministry of Lands and Natural Resources",
    "Ministry of Home Affairs and Internal Security",
    "Ministry of Energy",
    "Ministry of Technology and Science",
    "Ministry of Foreign Affairs and International Cooperation",
    "Ministry of Commerce, Trade and Industry",
    "Ministry of Education",
    "Ministry of Water Development and Sanitation",
    "Ministry of Tourism",
    "Ministry of Finance and National Planning",
    "Ministry of Community Development and Social Services",
    "Ministry of Small and Medium Enterprise Development",
    "Ministry of Green Economy and Environment",
    "Ministry of Transport and Logistics",
    "Ministry of Health",
    "Ministry of Youth, Sport and Arts",
    "Ministry of Local Government and Rural Development",
    "Ministry of Fisheries and Livestock",
    "Ministry of Infrastructure, Housing and Urban Development",
    "Ministry of Information and Media",
    "Zambia Public Procurement Authority (ZPPA)",
    "Anti-Corruption Commission (ACC)",
    "Patents and Companies Registration Agency (PACRA)",
    "Energy Regulation Board (ERB)",
    "Finance Intelligence Centre (FIC)",
    "Zambia National Building Society (ZNBS)",
    "Zambia Electricity Supply Corporation (ZESCO)",
    "National Road Fund Agency (NRFA)",
    "Securities and Exchange Commission (SEC)",
    "Zambia Revenue Authority (ZRA)",
    "National Pension Scheme Authority (NAPSA)",
    "Industrial Development Corporation (IDC)"
];

const slugify = (value) => value.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
const INSTITUTION_NAMES = INSTITUTIONS.reduce((map, name) => ({ ...map, [slugify(name)]: name }), {});
const institutionName = (slug) => INSTITUTION_NAMES[slug] || capitalize(String(slug || '').replace(/_/g, ' ')) || '—';

const STATUS_COLORS = {
    submitted: 'primary',
    under_review: 'info',
    shortlisted: 'success',
    placed: 'success',
    rejected: 'destructive',
    withdrawn: 'secondary'
};

const statusLabel = (status) => capitalize(String(status || 'submitted').replace(/_/g, ' '));

// KTDataTable renders column output as HTML, so escape applicant-entered text
const escapeHtml = (value) => String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

const Internship = () => {
    document.title = "Internship";

    const token = localStorage.getItem('jwtToken');
    const [selected, setSelected] = useState(null);
    const [reset, setReset] = useState(new Date().getTime());
    const datatableRef = useRef(null);

    useEffect(() => {
        getInternshipReport().then((response) => {
            if(!response.error) {
                $('#total-count').text(formatNumber(response.payload.total, "digit"));
                $('#total-submitted').text(formatNumber(response.payload.submitted, "digit"));
                $('#total-shortlisted').text(formatNumber(response.payload.shortlisted, "digit"));
                $('#total-rejected').text(formatNumber(response.payload.rejected, "digit"));
            }
        });
    }, [reset]);

    // ─── View click handler via event delegation ──────────────────────────────
    useEffect(() => {
        const handler = (e) => {
            const btn = e.target.closest('.applicant-view-btn');
            if (!btn) return;

            e.preventDefault();
            e.stopPropagation();

            try {
                const encoded = btn.getAttribute('data-row');
                const row = JSON.parse(decodeURIComponent(escape(atob(encoded))));
                setSelected(row);

                const el = document.getElementById("view-modal");
                if (!el) return;
                let modal = window.KTModal?.getInstance(el);
                if (!modal) modal = new window.KTModal(el);
                modal.show();

                // Init tabs after modal is visible
                setTimeout(() => {
                    if (window.KTTabs?.createInstances) {
                        window.KTTabs.createInstances();
                    }
                }, 100);
            } catch (err) {
                console.error("Failed to parse row data:", err);
            }
        };

        document.addEventListener('click', handler);
        return () => document.removeEventListener('click', handler);
    }, []);

    const closeViewModal = () => {
        const el = document.getElementById("view-modal");
        if (!el) return;
        let modal = window.KTModal?.getInstance(el);
        if (!modal) modal = new window.KTModal(el);
        modal.hide();
        setSelected(null);
    };

    // ─── Datatable ────────────────────────────────────────────────────────────
    useEffect(() => {
        var KTDatatableRemoteDataDemo = (function () {
            var isInitialized = false;
            var instance = null;

            var resolveDataTableClass = function () {
                if (typeof window === 'undefined') return null;
                if (window.KTDataTable) return window.KTDataTable;
                if (window.KTUI && window.KTUI.KTDataTable) return window.KTUI.KTDataTable;
                return null;
            };

            var init = function () {
                var KTDataTable = resolveDataTableClass();
                if (!KTDataTable) { setTimeout(init, 100); return null; }
                if (isInitialized && instance) return instance;

                var datatableEl = document.getElementById('kt_datatable_remote_source');
                if (!datatableEl) return null;

                if (datatableEl.hasAttribute('data-kt-datatable-initialized')) {
                    if (typeof KTDataTable.getInstance === 'function') {
                        var oldInstance = KTDataTable.getInstance(datatableEl);
                        if (oldInstance && typeof oldInstance.dispose === 'function') oldInstance.dispose();
                    }
                    datatableEl.removeAttribute('data-kt-datatable-initialized');
                    if (datatableEl.instance) delete datatableEl.instance;
                }

                var datatable = new KTDataTable(datatableEl, {
                    apiEndpoint: GET_INTERNSHIP_AGGREGATE_DATA,
                    requestMethod: 'POST',
                    requestHeaders: {
                        Authorization: token,
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                    mapRequest: function () {
                        const state = datatable?.getState?.() || {};
                        const pageIndex = (datatable?.getState?.().page ?? 1) - 1;
                        const pageSize = datatable?.getState?.().pageSize || 0;

                        return JSON.stringify({
                            query: state?.search || '',
                            collection: 'internship',
                            searchableFields,
                            filter,
                            pageSize: pageIndex * pageSize,
                            format: 'json',
                            populate: [
                                {
                                    path: "user",
                                    model: "user"
                                }
                            ],
                            sort: { _id: -1 }
                        });
                    },
                    mapResponse: function (res) {
                        return {
                            data: res.data || [],
                            totalCount: res.total || 0,
                        };
                    },
                    columns: {
                        user: {
                            title: 'Name',
                            render: function (value) {
                                return value?.name ? escapeHtml(capitalize(value.name)) : '—';
                            },
                        },
                        "preference.ministry": {
                            title: 'Ministry / Institution',
                            render: function (value, row) {
                                return escapeHtml(institutionName(row?.preference?.ministry));
                            }
                        },
                        "preference.district": {
                            title: 'Preferred Location',
                            render: function (value, row) {
                                const { province, district } = row?.preference || {};
                                return province ? `${escapeHtml(district)}, ${escapeHtml(province)}` : '—';
                            }
                        },
                        status: {
                            title: 'Status',
                            render: function (value) {
                                const status = value || 'submitted';
                                return `
                                    <span class="kt-badge kt-badge-${STATUS_COLORS[status] || 'secondary'}">
                                        ${statusLabel(status)}
                                    </span>
                                `;
                            },
                        },
                        createdAt: {
                            title: 'Date',
                            render: function (value) {
                                return value ? moment(value).format('DD MMM YYYY') : '—';
                            },
                        },
                        _id: {
                            title: 'Action',
                            render: function (value, row) {
                                const encoded = btoa(unescape(encodeURIComponent(JSON.stringify(row))));
                                return `
                                    <a class="kt-btn kt-btn-sm kt-btn-outline applicant-view-btn" href="#" data-row="${encoded}">
                                        <i class="ki-filled ki-eye"></i>
                                        View
                                    </a>
                                `;
                            }
                        }
                    },
                    pageSize: 10
                });

                isInitialized = true;
                instance = datatable;
                datatableRef.current = datatable;
                return instance;
            };

            return { init: function () { return init(); } };
        })();

        function safeInitialize() {
            var element = document.getElementById('kt_datatable_remote_source');
            if (!element) return;
            var inst = KTDatatableRemoteDataDemo.init();
            if (inst) window.datatableInstance = inst;
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', safeInitialize, { once: true });
        } else {
            setTimeout(safeInitialize, 1);
        }
    }, [token]);

    // ─── Helpers ──────────────────────────────────────────────────────────────
    const InfoRow = ({ label, value }) => (
        value ? (
            <div className="flex flex-col gap-0.5">
                <span className="text-xs text-muted-foreground">{label}</span>
                <span className="text-sm font-medium text-mono">{value}</span>
            </div>
        ) : null
    );

    const DocumentCard = ({ title, doc }) => (
        <div className="flex items-center justify-between p-4 rounded-lg border border-border bg-muted/20">
            <div className="flex items-center gap-3 min-w-0">
                <div className="size-9 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
                    <i className="ki-filled ki-document text-primary text-base"></i>
                </div>
                <div className="flex flex-col gap-0.5 min-w-0">
                    <span className="text-sm font-medium text-mono">{title}</span>
                    <span className="text-xs text-muted-foreground truncate">{doc?.name || 'PDF Document'}</span>
                </div>
            </div>
            {doc?.url ? (
                <a href={doc.url} target="_blank" rel="noopener noreferrer" className="kt-btn kt-btn-sm kt-btn-outline shrink-0">
                    <i className="ki-filled ki-exit-up text-sm"></i>
                    Open
                </a>
            ) : (
                <span className="text-xs text-muted-foreground">No file</span>
            )}
        </div>
    );

    const user = selected?.user;
    const preference = selected?.preference;
    const documents = selected?.documents || {};
    const cvDocuments = documents.cv || [];
    const supportingDocuments = documents.supporting_documents || [];
    const documentCount = (documents.application_letter ? 1 : 0) + cvDocuments.length + supportingDocuments.length;

    const reloadTable = () => {
        if (datatableRef.current && typeof datatableRef.current.reload === 'function') {
            datatableRef.current.reload();
        }
    };

    const changeStatus = (status, message) => {
        let {hide} = cogoToast.loading('Please wait... contacting to server.', {position: "top-right", hideAfter: 0});

        updateInternshipStatus({ id: selected._id, status }).then((result) => {
            hide();
            if(!result.error) {
                closeViewModal();
                reloadTable();
                setReset(new Date().getTime());
                cogoToast.success(message, {position: "top-right"});
            } else {
                cogoToast.error(result.payload || "Something went wrong.", {position: "top-right"});
            }
        });
    };

    // ─── Render ───────────────────────────────────────────────────────────────
    return (
        <div>
            {/* Page Header */}
            <div className="kt-container-fixed">
                <div className="flex flex-wrap items-center lg:items-end justify-between gap-5 pb-7.5">
                    <div className="flex flex-col justify-center gap-2">
                        <h1 className="text-xl font-medium leading-none text-mono">National Internship</h1>
                        <div className="flex items-center gap-2 text-sm font-normal text-secondary-foreground">
                            Review and manage internship applicants
                        </div>
                    </div>
                </div>
            </div>

            {/* Stats */}
            <div className="kt-container-fixed mb-10">
                <div className="grid grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-7.5 h-full items-stretch">
                    {[
                        { label: "Total Applicants", color: "text-primary", icon: "ki-users", id: "total-count" },
                        { label: "Shortlisted", color: "text-green-500", icon: "ki-check-circle", id: "total-shortlisted" },
                        { label: "Rejected", color: "text-destructive", icon: "ki-cross-circle", id: "total-rejected" },
                    ].map((stat, i) => (
                        <div key={i} className="kt-card flex-col justify-between gap-6 h-full bg-cover bg-[right_top_-1.7rem] bg-no-repeat channel-stats-bg">
                            <i className={`ki-filled ${stat.icon} text-2xl ${stat.color} w-7 mt-4 ms-5`}></i>
                            <div className="flex flex-col gap-1 pb-4 px-5">
                                <span className="text-3xl font-semibold text-mono" id={stat.id}>0</span>
                                <span className="text-sm font-normal text-secondary-foreground">{stat.label}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Table */}
            <div className="kt-container-fixed">
                <div className="kt-card mb-10">
                    <div className="kt-card-header">
                        <select className="kt-select w-40" data-kt-select="true" data-kt-select-placeholder="Select Status" name="kt-select" onChange={(e) => {
                            filter = {};
                            if (e.target.value !== 'all') filter.status = e.target.value;
                            reloadTable();
                        }}>
                            <option value="all">All Status</option>
                            <option value="submitted">Submitted</option>
                            <option value="shortlisted">Shortlisted</option>
                            <option value="rejected">Rejected</option>
                        </select>
                        <div className="kt-input max-w-48">
                            <i className="ki-filled ki-magnifier"></i>
                            <input type="text" placeholder="Search..." className="kt-input sm:w-48" data-kt-datatable-search="#kt_datatable_remote_source"/>
                        </div>
                    </div>
                    <div id="kt_datatable_remote_source" className="kt-card-table" data-kt-datatable-page-size="10"
                         data-kt-datatable-state-save="true">
                        <div className="kt-table-wrapper kt-scrollable">
                            <table className="kt-table" data-kt-datatable-table="true">
                                <thead>
                                <tr>
                                    <th scope="col" className="w-30" data-kt-datatable-column="user"><span
                                        className="kt-table-col"><span className="kt-table-col-label">Name</span><span
                                        className="kt-table-col-sort"></span></span></th>
                                    <th scope="col" className="w-40" data-kt-datatable-column="preference.ministry"><span
                                        className="kt-table-col"><span className="kt-table-col-label">Ministry / Institution</span><span
                                        className="kt-table-col-sort"></span></span></th>
                                    <th scope="col" className="w-30" data-kt-datatable-column="preference.district"><span
                                        className="kt-table-col"><span className="kt-table-col-label">Preferred Location</span><span
                                        className="kt-table-col-sort"></span></span></th>
                                    <th scope="col" className="w-24" data-kt-datatable-column="status"><span
                                        className="kt-table-col"><span className="kt-table-col-label">Status</span><span
                                        className="kt-table-col-sort"></span></span></th>
                                    <th scope="col" className="w-24" data-kt-datatable-column="createdAt"><span
                                        className="kt-table-col"><span className="kt-table-col-label">Date</span><span
                                        className="kt-table-col-sort"></span></span></th>
                                    <th scope="col" className="w-20" data-kt-datatable-column="_id"><span
                                        className="kt-table-col"><span
                                        className="kt-table-col-label">Action</span></span></th>
                                </tr>
                                </thead>
                                <tbody></tbody>
                            </table>
                        </div>
                        <div className="kt-datatable-toolbar">
                            <div className="kt-datatable-length">Show <select className="kt-select kt-select-sm w-16"
                                                                              name="perpage"
                                                                              data-kt-datatable-size="true"></select> per
                                page
                            </div>
                            <div className="kt-datatable-info">
                                <span data-kt-datatable-info="true"></span>
                                <div className="kt-datatable-pagination" data-kt-datatable-pagination="true"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ── View Modal ── */}
            <div className="kt-modal" data-kt-modal="true" id="view-modal">
                <div className="kt-modal-content max-w-[850px] top-[2%]">

                    {/* Modal Header */}
                    <div className="kt-modal-header">
                        <div className="flex items-center gap-3">
                            <div className="shrink-0 size-10 rounded-full bg-primary/10 flex items-center justify-center">
                                <i className="ki-filled ki-user text-primary text-lg"></i>
                            </div>
                            <div>
                                <h3 className="kt-modal-title">{capitalize(user?.name) || 'Applicant'}</h3>
                                <p className="text-sm text-secondary-foreground">
                                    Applied {selected ? moment(selected.createdAt).format('DD MMM YYYY') : '—'}
                                    {preference?.ministry ? ` · ${institutionName(preference.ministry)}` : ''}
                                </p>
                            </div>
                        </div>
                        <div className="flex items-center gap-2">
                            {selected && (
                                <span className={`kt-badge kt-badge-${STATUS_COLORS[selected.status] || 'secondary'}`}>
                                    {statusLabel(selected.status)}
                                </span>
                            )}
                            <button type="button" className="kt-modal-close" onClick={closeViewModal}>
                                <i className="ki-filled ki-cross text-lg"></i>
                            </button>
                        </div>
                    </div>

                    {/* Modal Body with Tabs */}
                    <div className="kt-modal-body p-0">
                        {selected && (
                            <div>
                                {/* ── KTTabs Nav ── */}
                                <div
                                    className="kt-tabs kt-tabs-line px-5 border-b border-border"
                                    data-kt-tabs="true"
                                    id="applicant-modal-tabs"
                                >
                                    <button className="kt-tab-toggle active" data-kt-tab-toggle="#tab_applicant">
                                        <i className="ki-filled ki-user text-sm"></i>
                                        Applicant
                                    </button>
                                    <button className="kt-tab-toggle" data-kt-tab-toggle="#tab_placement">
                                        <i className="ki-filled ki-geolocation text-sm"></i>
                                        Placement
                                    </button>
                                    <button className="kt-tab-toggle" data-kt-tab-toggle="#tab_documents">
                                        <i className="ki-filled ki-document text-sm"></i>
                                        Documents
                                        <span className="kt-badge kt-badge-sm kt-badge-primary ml-1">{documentCount}</span>
                                    </button>
                                </div>

                                {/* ── Tab Content ── */}
                                <div className="p-5">

                                    {/* Tab 1 — Applicant */}
                                    <div id="tab_applicant">
                                        <div className="grid grid-cols-2 gap-x-6 gap-y-4">
                                            <InfoRow label="Full Name" value={capitalize(user?.name)} />
                                            <InfoRow label="Gender" value={capitalize(user?.gender)} />
                                            <InfoRow label="NRC Number" value={user?.id_number} />
                                            <InfoRow label="Phone Number" value={selected.phone_number} />
                                            <InfoRow label="Email Address" value={selected.email} />
                                            <InfoRow label="Current Province" value={selected.current_location?.province} />
                                            <InfoRow label="Current District" value={selected.current_location?.district} />
                                        </div>

                                        <div className="grid grid-cols-2 gap-x-6 gap-y-4 mt-4 pt-4 border-t border-border">
                                            <InfoRow label="Highest Qualification" value={selected.education?.qualification} />
                                            <InfoRow label="Field / Programme of Study" value={selected.education?.field_of_study} />
                                        </div>

                                        <div className="grid grid-cols-2 gap-x-6 gap-y-4 mt-4 pt-4 border-t border-border">
                                            <InfoRow label="Consent Signed As" value={selected.consent?.name} />
                                            <InfoRow label="Consent Date" value={selected.consent?.accepted_at ? moment(selected.consent.accepted_at).format('DD MMM YYYY, HH:mm') : null} />
                                        </div>
                                    </div>

                                    {/* Tab 2 — Placement */}
                                    <div id="tab_placement" className="hidden">
                                        <div className="grid grid-cols-2 gap-x-6 gap-y-4">
                                            <InfoRow label="Institution Type" value={preference?.institution_type === 'quasi' ? 'Quasi-Government Institution' : 'Government Ministry'} />
                                            <InfoRow label="Ministry / Institution" value={institutionName(preference?.ministry)} />
                                            <InfoRow label="Preferred Province" value={preference?.province} />
                                            <InfoRow label="Preferred District" value={preference?.district} />
                                        </div>
                                        <p className="text-xs text-muted-foreground mt-4 pt-4 border-t border-border">
                                            Communication with candidates should be done via official Ministry emails only.
                                        </p>
                                    </div>

                                    {/* Tab 3 — Documents */}
                                    <div id="tab_documents" className="hidden">
                                        <div className="flex flex-col gap-3">
                                            <DocumentCard title="Application Letter" doc={documents.application_letter} />
                                            {cvDocuments.map((doc, i) => (
                                                <DocumentCard key={`cv-${i}`} title={`CV / Qualification ${cvDocuments.length > 1 ? i + 1 : ''}`.trim()} doc={doc} />
                                            ))}
                                            {supportingDocuments.map((doc, i) => (
                                                <DocumentCard key={`sd-${i}`} title={`Supporting Document ${supportingDocuments.length > 1 ? i + 1 : ''}`.trim()} doc={doc} />
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                {/* ── Modal Footer with Actions ── */}
                                <div className="flex items-center justify-between px-5 py-4 border-t border-border">
                                    <button type="button" className="kt-btn kt-btn-outline" onClick={closeViewModal}>
                                        Close
                                    </button>
                                    <div className="flex items-center gap-2">
                                        {selected.status !== 'rejected' && (
                                            <button type="button" className="kt-btn kt-btn-destructive kt-btn-sm" onClick={() => changeStatus('rejected', "Applicant successfully rejected.")}>
                                                <i className="ki-filled ki-cross-circle text-sm"></i>
                                                Reject
                                            </button>
                                        )}
                                        {selected.status !== 'shortlisted' && (
                                            <button type="button" className="kt-btn kt-btn-sm" style={{ backgroundColor: '#22c55e', color: '#fff' }} onClick={() => changeStatus('shortlisted', "Applicant successfully shortlisted.")}>
                                                <i className="ki-filled ki-check text-sm"></i>
                                                Shortlist
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Internship;
